/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2022-04-01 13:15:03
 * @LastEditors: Jack Deng
 * @LastEditTime: 2022-06-03 16:12:25
 * @FilePath: /unifyxp-shopper-pc-v2/src/utils/fetchJson/index.tsx
 */
export default async function fetchJson(
  input: RequestInfo,
  init?: RequestInit,
): Promise<any> {
  try {
    const response = await fetch(input, init);

    // if the server replies, there's always some data in json
    // if there's a network error, it will throw at the previous line
    const data = await response.json();

    if (data.errorCode) {
      throw new FetchError({
        message: data.errMsg,
        response,
        data,
      });
    }
    // response.ok is true when res.status is 2xx
    // https://developer.mozilla.org/en-US/docs/Web/API/Response/ok
    if (response.ok) {
      return data;
    }
  } catch (e) {
    console.log('fetchJson Error:', e);
    return Promise.reject(e);
  }
}

export class FetchError extends Error {
  response: Response;
  data: {
    message: string;
  };
  constructor({
    message,
    response,
    data,
  }: {
    message: string;
    response: Response;
    data: {
      message: string;
    };
  }) {
    // Pass remaining arguments (including vendor specific ones) to parent constructor
    super(message);

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, FetchError);
    }

    this.name = 'FetchError';
    this.response = response;
    this.data = data ?? { message: message };
  }
}
